/**
 * Created by: Lior Elrom
 * Date: 1/15/16
 * Time: 11:42 AM
 */

'use strict';

const PAGES = {
    PAGE_ACCOUNT: 'account',
    PAGE_CHECKOUT: 'checkout',
    PAGE_BALANCE_DUE: 'balanceDue',
    PAGE_CONFIRMATION: 'confirmation'
};

const PANES = {
    PANE_OFFER: 'offer',
    PANE_SIDEMARK: 'sidemark',
    PANE_SHIPPING: 'shipping',
    PANE_DELIVERY: 'delivery',
    PANE_PAYMENT: 'payment',
    PANE_REVIEW: 'review',
    PANE_SUMMARY: 'summary'
};

const STEPS = {
    STEP_SHIPPING: 'shipping',
    STEP_DELIVERY: 'delivery',
    STEP_PAYMENT: 'payment',
    STEP_REVIEW: 'review'
};

const STATES = {
    STATE_NEW: 'new',
    STATE_EDIT: 'edit',
    STATE_SAVED: 'saved',
    STATE_VERIFY: 'verify'
};

const TABS = {
    TAB_CREDIT_CARD: 'creditCard',
    TAB_PAYPAL_ACCOUNT: 'payPalAccount',
    TAB_WIRE_TRANSFER: 'wireTransfer',
    TAB_CHECK: 'check',
    TAB_APPLE_PAY: 'applePay'
};

const ACTIONS = {
    ACTION_EDIT: 'edit',
    ACTION_DELETE: 'delete',
    ACTION_CANCEL: 'cancel'
};

const MODELS = {
    MODEL_ADDRESS: 'address',
    MODEL_CARD: 'creditCard'
};

const METHODS = {
    METHOD_CREDIT_CARD: 'creditCard',
    METHOD_PAYPAL_ACCOUNT: 'payPalAccount',
    METHOD_WIRE_TRANSFER: 'wireTransfer',
    METHOD_CHECK: 'check',
    METHOD_APPLE_PAY: 'applePay'
};

const PAYMENTS = {
    TYPE_CREDIT_CARD: 'CreditCard',
    TYPE_PAYPAL_ACCOUNT: 'PayPalAccount',
    TYPE_WIRE_TRANSFER: 'WireTransfer',
    TYPE_CHECK: 'Check',
    TYPE_APPLE_PAY: 'ApplePay'
};

const VARS = {
    RESERVE_AMOUNT: 1,
    MAX_APP_AD_VIEWS: 3,
    MAX_ITEM_PRE_QUOTES: 2,
    MAX_PAYPAL_AMOUNT: 55000,
    MAX_WIRE_AMOUNT: 5000,
    MAX_RETURN_AMOUNT: 35000,
    ALLOW_CUSTOM_QUOTE: 10000,
    MAX_NOTE_LENGTH: 256,
    MAX_SIDEMARK_ERROR: 35,
    ZOOM_MOBILE_GUTTER: '5%',
    ZOOM_DESKTOP_GUTTER: '12%',
    SAVED_SCROLL_OFFSET: -16,
    STORAGE_PREFIX: 'trans_',
    COUNTRIES_NEEDS_ARTICLE: ['US', 'UK', 'GB', 'NL']
};

const CHAT = {
    FULL_PRICE: 'fullPrice',
    NEGOTIATED: 'negotiated',
    PRIVATE_OFFER: 'privateOffer',
    RETAIL: 'listPrice',
    WEEKLY_SALE: 'saturdaySale',
    NET: 'netPrice',
    BUYER_ID: 'buyerId',
    ITEM_PK: 'itemPk',
    DEALER_TRACKED_PHONE: 'dealerTrackedPhone',
    DEALER_UNTRACKED_PHONE: 'dealerUntrackedPhone',
    DEALER_NO_PHONE: 'dealerNoPhone',
    PREQUOTE_AVAILABLE: 'prequote_available',
    QUOTE_NEEDED: 'shippingQuoteNeeded'
};

const ERRORS = {
    ERROR_401: 401,
    ERROR_409: 409,
    ERROR_412: 412,
    ERROR_500: 500,
    ERROR_USER_EXISTS: 'USER_EXISTS',
    ERROR_VAULT: 'VAULT',
    ERROR_DENIED: 'DENIED',
    ERROR_EXPIRED: 'EXPIRED',
    ERROR_USER_CHANGED: 'USER_CHANGED',
    ERROR_ITEM_NOT_AVAILABLE: 'ITEM_NOT_AVAILABLE',
    ERROR_ITEM_QUANTITY_NOT_AVAILABLE: 'ITEM_QUANTITY_NOT_AVAILABLE'
};

module.exports = {
    PAGES,
    PANES,
    STEPS,
    STATES,
    TABS,
    ACTIONS,
    MODELS,
    METHODS,
    PAYMENTS,
    VARS,
    CHAT,
    ERRORS
};



// WEBPACK FOOTER //
// ./assets/js/checkout/models/checkoutConstants.es.js